import { toast, ToastOptions, Renderable, ValueOrFunction } from "react-hot-toast";

const defaultOptions: ToastOptions = {
  duration: 3500,
  position: "top-right",
};

const InfoIcon = () => (
  <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth={2}>
    <circle cx={12} cy={12} r={10} />
    <line x1={12} y1={11} x2={12} y2={16} />
    <circle cx={12} cy={8} r={0.5} fill="#2563eb" stroke="none" />
  </svg>
);

const WarningIcon = () => (
  <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth={2}>
    <path d="M12 3 L22 20 H2 Z" strokeLinejoin="round" />
    <line x1={12} y1={9} x2={12} y2={14} />
    <circle cx={12} cy={17} r={0.5} fill="#d97706" stroke="none" />
  </svg>
);

export const showSuccess = (message: Renderable, options: ToastOptions = {}): string => {
  return toast.success(message, { ...defaultOptions, className: "toast-success", ...options });
};

export const showError = (message: Renderable, options: ToastOptions = {}): string => {
  return toast.error(message, { ...defaultOptions, className: "toast-error", ...options });
};

export const showInfo = (message: Renderable, options: ToastOptions = {}): string => {
  return toast(message, {
    ...defaultOptions,
    icon: <InfoIcon />,
    className: "toast-info",
    ...options,
  });
};

export const showWarning = (message: Renderable, options: ToastOptions = {}): string => {
  return toast(message, {
    ...defaultOptions,
    icon: <WarningIcon />,
    className: "toast-warning",
    ...options,
  });
};

export const showLoading = (message: Renderable, options: ToastOptions = {}): string => {
  return toast.loading(message, { ...defaultOptions, className: "toast-loading", ...options });
};

export const showPromise = <T,>(
  promise: Promise<T>,
  msgs: {
    loading: Renderable;
    success: ValueOrFunction<Renderable, T>;
    error: ValueOrFunction<Renderable, any>;
  },
  options: ToastOptions = {}
): Promise<T> => {
  return toast.promise(promise, msgs, { ...defaultOptions, ...options });
};

export const dismissToast = (toastId?: string): void => {
  toast.dismiss(toastId);
};

export const removeToast = (toastId?: string): void => {
  toast.remove(toastId);
};

const toastService = {
  success: showSuccess,
  error: showError,
  info: showInfo,
  warning: showWarning,
  loading: showLoading,
  promise: showPromise,
  dismiss: dismissToast,
  remove: removeToast,
  toast,
};

export default toastService;
